export const articleNoAccessTitle = 'Commentary & Deal Flow';

export const articleNoAccessFeatures = [
  'Filter by theme, industry/sector, deal, parent, issuer and more to identify relevant reporting',
  'Discover relevant commentary and deal flow reports on parent, issuer, industry/sector and deal profiles',
  'Subscribe to real-time email alerts for new commentary and deal flow',
];

export const articleNoAccessDescription = 'Inform strategic decisions with real-time deal flow and commentary written by industry leading analysts with years of reporting experience.';

export const articleImageCaption = 'Commentary & deal flow are mapped to parent, issuer, industry/sector and deal to enable rapid search and filtering.';
